// api.js
import axios from 'axios'

// 创建一个 axios 实例
const instance = axios.create({
  baseURL: 'https://mdy-n.modianyun.com', // 替换为你的 API 基础地址
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 在发送请求之前做一些处理，比如添加 token
    const token = localStorage.getItem('token') // 从本地获取 token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 处理请求错误
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 处理响应数据
    return response.data
  },
  error => {
    // 处理响应错误
    console.error('API Error: ', error)
    return Promise.reject(error)
  }
)

// 封装常用请求方法
export default {
  get (url, params = {}) {
    return instance.get(url, { params })
  },
  post (url, data = {}) {
    return instance.post(url, data)
  },
  put (url, data = {}) {
    return instance.put(url, data)
  },
  delete (url, data = {}) {
    return instance.delete(url, { data })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js